import { entityBrowserConstants } from '../constants/entityBrowserConstants';

export const entityBrowserActions = {
    fetchExpandedNodeIds,
    updateSelectedNodeIds,
    updateExpandedNodeIds,
};

function fetchExpandedNodeIds() {
    return async (dispatch, getState) => {
        dispatch(request());

        try {
            const expandedNodeIds =  getState().entityBrowser.expandedNodeIds;

            if (expandedNodeIds == null) {
                throw new Error('ExpandedNodeIds does not exist.');
            }

            dispatch(success(expandedNodeIds.slice()));
        } catch (error) {
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to fetch expandedNodeIds at this moment. Please try again later.'));
            }
        }

        function request() {
            return {
                type: entityBrowserConstants.FETCH_EXPANDED_NODE_ID_REQUEST,
            };
        }
        function success(expandedNodeIds) {
            return {
                type: entityBrowserConstants.FETCH_EXPANDED_NODE_ID_SUCCESS,
                expandedNodeIds,
            };
        }
        function failure(error) {
            return {
               type: entityBrowserConstants.FETCH_EXPANDED_NODE_ID_FAILURE,
                error,
            };
        }
    };
}


function updateSelectedNodeIds(selectedNodeIds) {
    return async (dispatch) => {
        dispatch(request());

        try {
            dispatch(success(selectedNodeIds.slice()));
        } catch (error) {
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to update selectedNodeIds at this time.'));
            }
        }
    };

    function request() {
        return { type: entityBrowserConstants.UPDATE_SELECTED_NODE_ID_REQUEST };
    }
    function success(updatedSelectedNodeIds) {
        return {
            type: entityBrowserConstants.UPDATE_SELECTED_NODE_ID_SUCCESS,
            updatedSelectedNodeIds,
        };
    }
    function failure(error) {
        return {
            type: entityBrowserConstants.UPDATE_SELECTED_NODE_ID_FAILURE,
            error,
        };
    }
}

function updateExpandedNodeIds(updatedExpandedNodeIds) {
    return async (dispatch) => {
        dispatch(request());

        try {
            dispatch(success(updatedExpandedNodeIds.slice()));
        } catch (error) {
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to fetch updatedExpandedNodeIds at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: entityBrowserConstants.UPDATE_EXPANDED_NODE_ID_REQUEST };
    }
    function success(updatedExpandedNodeIds) {
        return {
            type: entityBrowserConstants.UPDATE_EXPANDED_NODE_ID_SUCCESS,
            updatedExpandedNodeIds,
        };
    }
    function failure(error) {
        return {
            type: entityBrowserConstants.UPDATE_EXPANDED_NODE_ID_FAILURE,
            error,
        };
    }


}
